export default __webpack_public_path__ + "static/media/icon-card-bug.6726dadf.svg";